<template lang="pug">
    .settings(v-if='localSettings.length')
        template(v-for="(settings, index) in localSettings")
            divider(v-if="index > 0", :margin="'10px auto'")
            template(v-if="settings.withTime && settings.speed && parametersFrom === 'homework'")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_speed') }}:
                | {{ settings.speed.value }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_wordsPerMinute') }}
                br
            template
                span
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_mode')}}: {{ getModeName(settings) }}
                br
                template(v-if="typeof settings.mode !== 'object' || parametersFrom === 'course'")
                    template(v-if='settings.textLabel')
                        span
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_textLabel') }}: {{ settings.textLabel }}
                        br
                    template(v-else-if='settings.sourceText')
                        span
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_textIsSelected') }}
                        br
                    template(v-if='settings.settings.allQuestions')
                        span
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_allQuestions') }}:
                            | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                        br
                    template(v-if='settings.settings.endLetters')
                        span
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_withoutEndLetters') }}:
                            | {{ settings.settings.letters }}
                        br
                    template(v-if='settings.settings.centralLetters')
                        span
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_withoutCentralLetters') }}:
                            | {{ settings.settings.letters }}
                        br
                    template(v-if='settings.settings.withoutWord')
                        span
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_withoutWord') }}:
                            | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                        br
                    template(v-if='settings.settings.anagrams')
                        span
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfAnagrams') }}:
                            | {{ settings.settings.anagrams.label }}
                        br
                    template(v-if='settings.settings.mirrorText')
                        span
                            | {{ $i18n.t('trainer.trainer_gameFormSettings_amountOfMirrorWords') }}:
                            | {{ settings.settings.mirrorText.label }}
                        br
                    template(v-if='settings.settings.invertText')
                        span
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_invertText') }}:
                            | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
                        br
                    template(v-if='settings.withTime && settings.settings.words')
                        span
                            | {{ $i18n.t('trainer.trainer_gameFormSetting_amountOfWords') }}:
                            | {{ settings.settings.words }}
                        br
            template(v-if="parametersFrom === 'homework'")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_metronome') }}:
                | {{ getFormattedBPM(settings) }}
                br
            template(v-if="settings.dueDate")
                span
                    | {{ $i18n.t('homework.homework_create_executeTime') }}:
                    | {{ getFormattedDate(settings.dueDate) }}
                br
            slot
</template>

<script>
    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';
    import { getFormattedDate } from '../../../utils/getFormattedDate';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            userId: Number,
            parametersFrom: {
                type: String,
                default: 'homework',
            },
        },
        data() {
            return {
                localSettings: [],
            };
        },
        watch: {
            settings: {
                handler(val) {
                    this.localSettings = Array.isArray(val) ? val : [val];
                },
                immediate: true,
            },
        },
        methods: {
            getFormattedDate,
            getModeName(settings) {
                if (typeof settings.mode === 'string') {
                    return this.$i18n.t('trainer.trainer_gameFormSettingValue_' + settings.mode);
                } else if (this.parametersFrom !== 'homework') {
                    return settings.mode
                        .map(name => this.$i18n.t('trainer.trainer_gameFormSettingValue_' + name))
                        .join(', ');
                }
                return this.$i18n.t('trainer.trainer_gameFormSettingValue_static');
            },
            getFormattedBPM(settings) {
                return settings.metronomeSpeed
                    ? `${settings.metronomeSpeed} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_bpm')
                    : this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated');
            },
        },
    };
</script>
